<template lang="pug">
div
  v-btn(
    v-if="hasPermission('can_add_folio')"
    color="green"
    class="ma-2 white--text"
    @click="showEmptyForm") Cargar Documento
    v-icon(z
      right
      dark) mdi-cloud-upload
  confirm-dialog(
    v-model="showDeleteModal"
    @confirm="confirmDelete"
    :loading="loadingAction"
    :message="'Al eliminar este Documento ya no podrá ser visto desde los folios asociados.'")
  div
    v-card(class="mt-2")
      v-card-title
        v-text-field(
          ref="inputSearch"
          v-model="search"
          label="Buscar documentos"
          single-line
          hide-details
          :append-icon="`${search === '' ? 'mdi-magnify' : 'mdi-trash-can-outline'}`"
          @click:append="search = ''")
        v-divider(
          class="mx-4"
          inset
          vertical)
        v-btn(
          :loading="loadingDocuments"
          color="info"
          dark
          class="mr-2"
          @click="fetchDocuments")
          | Refrescar Elementos
      v-data-table(
        :headers="headers"
        :items="documents"
        :loading="loadingDocuments"
        loading-text="Cargando Documentos... Por favor espere"
        hide-default-footer
        :page.sync="page"
        disable-pagination)
        template(v-slot:item.id="{ item }")
          b {{documents.map(function(x) {return x.id; }).indexOf(item.id) + (pageSize * (page - 1) + 1)}}
        template(v-slot:item.fecha_carga="{ item }")
          | {{ formatDate(item.fecha_carga) }}
        template(v-slot:item.anotaciones_documento="{ item }")
          v-chip(
            v-for="a in item.anotaciones_documento"
            :key="a.folio_anotacion.id"
            :to="`/folios/${a.folio_anotacion.id}/detail`"
            class="ma-2 font-weight-bold"
            color="primary") 
              | <b class="mr-1">{{ a.numero }}</b> -> {{a.folio_anotacion.numero_matricula}}
        template(v-slot:item.options="{ item }")
          v-tooltip(top)
            template(v-slot:activator="{ on, attrs }")
              v-btn(
                color="gray"
                icon
                @click="showDocument(item)"
                v-bind="attrs"
                v-on="on")
                v-icon mdi-file-pdf-box
            span Ver PDf del documento
          v-tooltip(top)
            template(v-slot:activator="{ on, attrs }")
              v-btn(
                color="gray"
                icon
                @click="detailDocument(item.id)"
                v-bind="attrs"
                v-on="on")
                v-icon mdi-information
            span Ver detalle documento
          v-tooltip(top v-if="hasPermission('can_change_document')")
            template(v-slot:activator="{ on, attrs }")
              v-btn(
                color="gray"
                icon
                @click="showEditForm(item)"
                v-bind="attrs"
                v-on="on")
                v-icon mdi-pencil
            span Editar documento
          v-tooltip(top v-if="hasPermission('can_delete_document')")
            template(v-slot:activator="{ on, attrs }")
              v-btn(
                color="gray"
                icon
                @click="initDelete(item.id)"
                v-bind="attrs"
                v-on="on")
                v-icon mdi-trash-can
            span Eliminar el documento
            
      v-divider
      v-row(class="mx-5 mt-2")
        v-col(cols="4" sm="3")
          v-select(
            v-model="pageSize"
            :items="pageSizes"
            label="Items per Page"
            @change="handlePageSizeChange")
        v-spacer
        v-col(cols="12" sm="9")
          v-pagination(
            v-model="page"
            :length="totalPages"
            total-visible="7"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange")
</template>

<script>
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
import documentMixin from '@/mixins/documentMixin.js';
import debounce from 'debounce';
import ConfirmDialog from '@/components/ui/ConfirmDialog';
import { formatDate } from '@/utils';

export default {
  name: 'DocumentsList',

  components: {
    ConfirmDialog,
  },

  mixins: [documentMixin],

  data: () => ({
    page: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50],
    search: '',
    // estado para mostrar el modal para eliminar
    showDeleteModal: false,
    // estado para almacenar el documento seleccionado
    targetDocumentId: null,
    // esatdo para indicar que esta cargando la accion del modal
    loadingAction: false,
    headers: [
      {
        text: '#',
        align: 'start',
        filterable: false,
        value: 'id',
      },
      { 
        text: 'Documento',
        value: 'nombre',
        align: 'left'
      },
      { 
        text: 'Fecha Documento',
        value: 'fecha_documento',
        align: 'center'
      },
      { 
        text: 'Municipio',
        value: 'municipio.nombre',
        align: 'center'
      },
      {
        text: 'Tipo',
        value: 'tipo.nombre',
        align: 'center'
      },
      {
        text: 'Entidad Emisora',
        value: 'entidad_emisora',
        align: 'center'
      },
      {
        text: 'Folios Asociados',
        value: 'anotaciones_documento',
        align: 'center'
      },
      { 
        text: 'Numero Documento',
        value: 'numero_documento'
      },
      { 
        text: 'Usuario carga',
        value: 'usuario_documento.full_name'
      },
      { 
        text: 'Fecha carga',
        value: 'fecha_carga'
      },
      { 
        text:
        'Opciones',
        value: 'options'
      },
    ],
  }),

  computed: {
    ...mapState('documents', [
      'documents',
      'totalPages',
      'loadingDocuments',
      'documentLoaded',
    ]),
    ...mapGetters('auth', ['hasPermission']),
  },

  watch: {
    documentLoaded: {
      handler(newVal) {
        if (newVal) {
          this.fetchDocuments();
        }
      }
    },
    search: {
      handler(newVal) {
        if (newVal === null) return;
        if (newVal.length >= 3 || newVal.length === 0) {
          this.debounceInput();
        }
      }
    },
  },

  async mounted() {
    await this.getDocumentDomains();
    await this.getDocuments({
      pageSize: this.pageSize,
      page: this.page,
      searchQuery: this.search
    });
  },

  methods: {
    ...mapMutations('ui', [
      'TOGGLE_DIALOG',
      'SET_DIALOG_CONTENT',
      'SET_DIALOG_TITLE',
      'CHANGE_VALUE',
    ]),
    ...mapActions('documents', [
      'getDocuments',
      'deleteDocument',
      'getDocumentDomains',
      'getFolioDetail',
    ]),
    formatDate,
    // metodo para buscar documentos
    async fetchDocuments() {
      this.page = 1;
      await this.getDocuments({
        pageSize: this.pageSize,
        page: this.page,
        searchQuery: this.search
      });
    },
    debounceInput: debounce(async function () {
      this.page = 1;
      await this.getDocuments({
        pageSize: this.pageSize,
        page: this.page,
        searchQuery: this.search
      });
      this.$refs.inputSearch.focus();
    }, 500),
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getDocuments({
        pageSize: this.pageSize,
        page: this.page,
        searchQuery: this.search
      });
    },
    handlePageChange(value) {
      this.page = value;
      this.getDocuments({
        pageSize: this.pageSize,
        page: this.page,
        searchQuery: this.search
      });
    },
    // metodo para inciar la eliminación del doumento
    showEditForm(document) {
      console.log('showEditForm' ,document);
      this.CHANGE_VALUE({
        varName: 'modalWidth',
        value: '50%',
      });
      this.CHANGE_VALUE({
        varName: 'showModalOptions',
        value: false,
      });
      this.CHANGE_VALUE({
        varName: 'currentProperties',
        value: {
          annotationData: {
            entity: document.entidad_emisora,
            name: document.nombre,
            date: document.fecha_documento,
            number: document.numero_documento,
            documentType: document.tipo.nombre,
            selectedCity: document.municipio.nombre,
            selectedCityCode: document.municipio.codigo,
          },
          annotationId: '',
          documentId: document.id,
        },
      });
      this.SET_DIALOG_CONTENT('DocumentForm');
      this.SET_DIALOG_TITLE('Editar documento');
      this.TOGGLE_DIALOG(true);
    },
    initDelete(documentId) {
      this.showDeleteModal = true;
      this.targetDocumentId = documentId
    },
    // metodo para eliminar el documento
    async confirmDelete() {
      this.loadingAction = true;
      const res = await this.deleteDocument(this.targetDocumentId);
      if (res.deleted) {
        this.showDeleteModal = false;
        this.targetDocumentId = null;
        await this.fetchDocuments();
      }
      this.loadingAction = false;
    }
  },
   
};
</script>
